const arrows = {
  desktopGreenArrow: (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.15759 30.8719L5.92189 26.865L1.91495 26.6293"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.1647 26.8641L9.92897 22.8572L5.92203 22.6215"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.1715 22.8583L13.9358 18.8513L9.92887 18.6156"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.1786 18.8505L17.9429 14.8435L13.936 14.6078"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22.1854 14.8446L21.9497 10.8377L17.9428 10.602"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M26.1923 10.8368L25.9566 6.82985L21.9496 6.59415"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30.1993 6.82898L29.9636 2.82204L25.9567 2.58634"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  desktopRedArrow: (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.91516 5.57337L5.9221 5.33766L6.1578 1.33073" stroke="#F23F37" strokeWidth="2" strokeLinecap="round" />
      <path d="M5.922 9.57923L9.92894 9.34352L10.1646 5.33658" stroke="#F23F37" strokeWidth="2" strokeLinecap="round" />
      <path d="M9.92883 13.587L13.9358 13.3513L14.1715 9.3444" stroke="#F23F37" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M13.9359 17.5929L17.9429 17.3572L18.1786 13.3503"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.9428 21.6007L21.9497 21.365L22.1854 17.3581"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21.9498 25.6066L25.9568 25.3709L26.1925 21.3639"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M25.9567 29.6144L29.9636 29.3787L30.1993 25.3717"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  mobileGreenArrow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.38465 14.4247L5.14894 10.4177L1.142 10.182" stroke="#0CC76E" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M9.39173 10.4208L9.15602 6.41384L5.14908 6.17813"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.3986 6.41296L13.1629 2.40602L9.15592 2.17032"
        stroke="#0CC76E"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  mobileRedArrow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.14221 5.66907L5.14915 5.43337L5.38485 1.42643"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M5.14905 9.67688L9.15599 9.44118L9.39169 5.43424"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.15589 13.6808L13.1628 13.4451L13.3985 9.43815"
        stroke="#F23F37"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
};

// export keys as type for use in other files
export type ArrowKeys = keyof typeof arrows;

export { arrows };
